export default "__VITE_ASSET__kvEifkeH__"